import * as React from "react";
import CTA, { CTATheme } from "../../components/common/CallToAction";
import * as _ from "lodash";
import TypeAhead, { TypeAheadElement, TypeAheadResults } from "../../components/TypeAhead";
import { ApiManager } from "../../api/ApiManager";
import IInterventionCatalogueResponse from "../../models/maverick/IInterventionsCatalogueResponse";


export interface IIntervention {
    interventionId: string,
    interventionCategory: string,
    originalInterventionText: string,
    modifiedInterventionText: string,
    parameterizedValue?: any;
}

interface InterventionEditViewContProp {
    interventions: IIntervention[],
    appointmentId: number
}

interface InterventionEditViewContState {
    updatedInterventions: IIntervention[]
    editMode: string,
    currIndex: number,
    currIntervention: IIntervention,
    searchInputText: string,
    recommendations?: any
}


interface IInterventionCategoryType {
    name: string,
    icon: string
}
const staticInterventionCategories: IInterventionCategoryType[] = [{ name: "NUTRITION", icon: "/images/food.svg" }, { name: "FITNESS", icon: "/images/excercise.svg" }, { name: "MINDFULNESS", icon: "/images/mindful.svg" }, { name: "MEDICATION", icon: "/images/medication.svg" }, { name: "HABITS", icon: "/images/habit.svg" }];

export enum EditViewMode {
    EDIT = 'EDIT',
    VIEW = 'VIEW',
    EDIT_VIEW = 'EDIT_VIEW'
}

export default class InterventionEditViewCont extends React.Component<InterventionEditViewContProp, InterventionEditViewContState> {

    constructor(props: InterventionEditViewContProp) {
        super(props)
        this.state = this.getStateFromProps(props);
    }

    componentDidMount(): void {
        ApiManager.careRecommendationServiceApis.getInterventionRecommendations().then((res: any) => {
            this.setState({ recommendations: res || [] });
        }).catch((err: any) => {
            this.setState({ recommendations: [] });
        });
    }

    getStateFromProps = (props: InterventionEditViewContProp): InterventionEditViewContState => {
        let updatedInterventions: IIntervention[] = props.interventions || [];
        return {
            updatedInterventions,
            currIndex: updatedInterventions.length,
            editMode: EditViewMode.VIEW,
            currIntervention: null,
            searchInputText: "",
        }
    }


    getSaveObject = () => {
        return {
            patientInterventionItemList: this.state.updatedInterventions || [],
            referenceId: this.props.appointmentId.toString(),
        }
    }

    onCategorySelect = (category: string) => {
        this.setState({ currIntervention: { ...this.state.currIntervention, interventionCategory: category }, editMode: EditViewMode.EDIT });
    }

    onInterventionsTypeAheadChange = async (input: string) => {
        this.setState({ searchInputText: input });
        let typeAheadResults: TypeAheadResults;
        const typeAheadArray: TypeAheadElement[] = [];

        return ApiManager.maverickApis.getCommonInterventions(input).then((results: IInterventionCatalogueResponse[]): Promise<TypeAheadResults> => {
            if (results.length) {
                _.map(results, (intervention) => {
                    if (this.state.currIntervention.interventionCategory !== intervention.interventionCategory) return;
                    const typeAheadElement = {
                        value: intervention.interventionText,
                        label: intervention.interventionText,
                        others: {
                            id: intervention.esId,
                            interventionId: intervention.interventionId,
                            interventionCategory: intervention.interventionCategory,
                        }
                    }
                    typeAheadArray.push(typeAheadElement);
                })
                typeAheadResults = { options: typeAheadArray, completed: true };
                return Promise.resolve(typeAheadResults);
            } else {
                return Promise.resolve({ options: [], completed: false });
            }
        }).catch((error: any) => {
            throw error;
        });
    };

    onInterventionsTypeAheadSelect = (elem: TypeAheadElement) => {
        const intervention: IIntervention = {
            interventionId: elem.others.interventionId,
            originalInterventionText: elem.value,
            modifiedInterventionText: elem.value,
            interventionCategory: elem.others.interventionCategory
        };

        this.setState({ currIntervention: intervention, searchInputText: "" });
        this.editViewHandler();
    };


    editViewHandler = () => {
        this.setState({ editMode: EditViewMode.EDIT_VIEW });
    }

    saveCurrentIntervention = () => {
        //currentIntervention.push(this.state.currentInputText);
        const index = this.state.currIndex;
        //const category = this.state.currIntervention.interventionCategory
        const updatedInterventions: IIntervention[] = [...this.state.updatedInterventions];
        updatedInterventions[index] = this.state.currIntervention;

        this.setState({ updatedInterventions, editMode: EditViewMode.VIEW, currIntervention: { interventionCategory: "", interventionId: "", originalInterventionText: "", modifiedInterventionText: "" }, currIndex: updatedInterventions.length });

    }

    onCurrentInterventionTextChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const input: string = e.target.value;
        this.setState({ currIntervention: { ...this.state.currIntervention, modifiedInterventionText: input } });
    }

    editSelectedIntervention = (index: number, intervention: IIntervention) => {
        this.setState({ currIndex: index, currIntervention: { ...intervention }, editMode: EditViewMode.EDIT_VIEW });
    }

    deleteCurrentIntervention = (index: number) => {
        const updatedInterventions = [...this.state.updatedInterventions];
        if (index !== this.state.updatedInterventions.length) updatedInterventions.splice(index, 1);
        // index !== this.state.currIndex || updatedInterventions.splice(index, 1);
        // console.log(index, this.state.currIndex, updatedInterventions);

        const currIntervention: IIntervention = {
            interventionId: "",
            interventionCategory: "",
            originalInterventionText: "",
            modifiedInterventionText: ""

        }
        this.setState({
            updatedInterventions, currIntervention, editMode: EditViewMode.VIEW, currIndex: updatedInterventions.length, searchInputText: ""
        })
    }

    cancelCurrentIntervention = () => {
        const currIntervention: IIntervention = {
            interventionId: "",
            interventionCategory: "",
            modifiedInterventionText: "",
            originalInterventionText: ""

        }
        this.setState({
            currIntervention, editMode: EditViewMode.VIEW, currIndex: this.state.updatedInterventions.length, searchInputText: ""
        })
    }

    quickTagSelectHandler = (selectedRecmd: any) => {
        const intervention: IIntervention = {
            interventionId: selectedRecmd.interventionId,
            originalInterventionText: selectedRecmd.interventionText,
            modifiedInterventionText: selectedRecmd.interventionText,
            interventionCategory: selectedRecmd.interventionCategory
        };

        this.setState({ currIntervention: intervention, searchInputText: "" });
        this.editViewHandler();
    }

    getFilteredRecommendationsList = () => {
        return _.filter(this.state.recommendations, (recmd: any): boolean => recmd.interventionCategory === this.state.currIntervention.interventionCategory);
    }


    getCommonEditViewCont = () => {
        const isEditViewMode = this.state.editMode === EditViewMode.EDIT_VIEW;
        const isEditMode = this.state.editMode === EditViewMode.EDIT;
        const isLastChild = this.state.currIndex === this.state.updatedInterventions.length;
        const ctaCss = { display: 'flex', justifyContent: 'center', alignItems: 'center', width: 90 }

        return (
            isEditViewMode || isEditMode ? <div className="quick-select-cont">
                <div className="quick-select-header">
                    <div className="quick-select-header__heading brandon-bold in-blk">{this.state.currIntervention.interventionCategory.toLowerCase()}</div>
                    <span className="clickable" onClick={() => this.deleteCurrentIntervention(this.state.currIndex)}> <img src="/images/delete.svg" /> </span>
                </div>

                {isEditMode ?
                    <div className="quick-select-cont__common-cont">
                        <div className="quick-select-cont__common-cont--heading brandon-bold">Commonly Used</div>
                        <div className="quick-select-cont__common-cont--tags" onClick={this.editViewHandler}>
                            {_.isEmpty(this.state.recommendations) || _.map(this.getFilteredRecommendationsList(), (recmd: any) => {
                                return <div key={recmd.id} onClick={() => this.quickTagSelectHandler(recmd)} className="toggleButton in-blk clickable">{recmd.interventionText}</div>
                            })}

                        </div>
                        <div className={"lc-intervention-search-cont"}>
                            <TypeAhead
                                widgetName={"InterventionEditViewCont"}
                                inputDisabled={false} name={"lc-intervention-search"}
                                value={this.state.searchInputText || ""}
                                placeholder={"Start typing to search"}
                                onTypeAheadChange={this.onInterventionsTypeAheadChange}
                                onTypeAheadSelect={this.onInterventionsTypeAheadSelect}
                                showSearchIcon />
                        </div>
                    </div> : isEditViewMode ? (<div className="lc-save-cont">
                        <div className="custom-input-box">
                            <input className="no-border-input" type="text" placeholder="" value={this.state.currIntervention.modifiedInterventionText || this.state.currIntervention.originalInterventionText} onChange={(e) => this.onCurrentInterventionTextChangeHandler(e)} />
                            {/* <img  className="clickable" src="/images/icons/cancel-grey.svg" onClick={() => { this.setState({ currIntervention: {...this.state.currIntervention, modifiedInterventionText:"" }}) }}/> */}
                        </div>
                        <div className="lc-save-cta-align">
                            {!isLastChild ? <CTA innerText={"Cancel"} theme={CTATheme.SECONDARY} onClick={this.cancelCurrentIntervention} customStyle={{ ...ctaCss, marginRight: '30px' }} /> : null}
                            <CTA innerText={"Save"} theme={CTATheme.PRIMARY} onClick={this.saveCurrentIntervention} customStyle={{ ...ctaCss, margin: '0' }} />
                        </div>
                    </div>) : null}

            </div> : null)
    }

    render() {
        const isViewMode = this.state.editMode === EditViewMode.VIEW;
        const isEditViewMode = this.state.editMode === EditViewMode.EDIT_VIEW;
        const isLastChild = this.state.currIndex === this.state.updatedInterventions.length;

        return (
            <div className={"card-view collapsible-card lc-intervention-editview-cont"}>
                <div className="lc-intervention-header">
                    <div className="lc-intervention-header__heading brandon-bold">Interventions</div>
                    {/* <div className="lc-intervention-header__side-option">Add From History</div> */}
                </div>

                {<div className="collapsible-container">
                    {_.map(this.state.updatedInterventions, (intervention: IIntervention, index: number) => (
                        this.state.currIndex === index && isEditViewMode ? this.getCommonEditViewCont()
                            : <div className={"lc-intervention-item-cont"}>
                                <div className="lc-intervention-item-header">
                                    <div className="lc-intervention-item-header__heading">
                                        <img src={`${(staticInterventionCategories.filter((cat: IInterventionCategoryType) => cat.name === intervention.interventionCategory))[0]?.icon}`} />
                                        <div className="brandon-bold">{intervention.interventionCategory.toLowerCase()}</div>
                                    </div>
                                    <div className="lc-intervention-item-header__options">
                                        <span onClick={() => this.editSelectedIntervention(index, intervention)} ><span className="clickable"> <img src="/images/text-edit.svg" /> </span></span>
                                        <span onClick={() => this.deleteCurrentIntervention(index)} className="clickable"> <img src="/images/delete.svg" /> </span>
                                    </div>

                                </div>
                                <div className="lc-intervention-item-text">{intervention.modifiedInterventionText || intervention.originalInterventionText}</div>
                            </div>
                    ))}
                </div>}

                { isViewMode ? <div className="lc-intervention-category-cont">
                    <div className="lc-intervention-category-cont__heading">Category</div>
                    <div>
                        {_.map(staticInterventionCategories, (category: IInterventionCategoryType, index: number) => (
                            <div key={index} className="toggleButton in-blk clickable" onClick={() => this.onCategorySelect(category.name)}>{category.name[0].toUpperCase() + category.name.slice(1)}</div>))}
                    </div>
                </div> : null}

                { isLastChild ? this.getCommonEditViewCont() : null}


            </div>
        )
    }
}
